export default __webpack_public_path__ + "assets/images/CT-Cardiac3.png";